import React from "react";
import { Redirect } from "react-router-dom";
import { clearSession } from '../../utils/sessionUtils';

class LogoutPage extends React.Component {
  render() {
    clearSession();

    return <Redirect to="/" />;
  }
}

export default LogoutPage;
